import React from 'react';
import PropTypes from 'prop-types';

function Minimize({ size = 40, className, onClick, state = false }) {
  return (
    <svg className={className} width={size} height={size} onClick={onClick} style={{cursor: `pointer`}} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#242424"/>
      <path d="M27 12H13C11.9 12 11 12.9 11 14V26C11 27.1 11.9 28 13 28H27C28.1 28 29 27.1 29 26V14C29 12.9 28.1 12 27 12ZM27.5 26C27.5 26.2761 27.2761 26.5 27 26.5H13C12.7239 26.5 12.5 26.2761 12.5 26V14C12.5 13.7239 12.7239 13.5 13 13.5H27C27.2761 13.5 27.5 13.7239 27.5 14V26Z" fill={!state ? `white` : `#34B642`}/>
      <path d="M14 15.5C14 15.2239 14.2239 15 14.5 15H25.5C25.7761 15 26 15.2239 26 15.5V16.5C26 16.7761 25.7761 17 25.5 17H14.5C14.2239 17 14 16.7761 14 16.5V15.5Z" fill={!state ? `white` : `#34B642`}/>
    </svg>
  )
}

Minimize.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  state: PropTypes.bool.isRequired
}

export default Minimize;
